/* eslint-disable */
/* @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { CarHistoryEvent } from "@mstys/raport-auta-client-front";
import { RaportHSPHistoryData } from "@/components/hsp2/HSPTimeline";
import {
  VehicleTimeline,
  VehicleTimelineEntry,
  VehicleTimelineEventType,
} from "./report";
import { Fragment } from "react";

type TranslationFunction = (
  key: string,
  defaultValue?: string,
  options?: { [key: string]: string | number }
) => string;

const parseDescription = (
  description: string[] | string | undefined
): string | React.ReactNode => {
  if (!description) {
    return "";
  }

  if (typeof description === "string") {
    return description;
  }
  return (
    <>
      {description.map((i, index) => (
        <Fragment
          key={`${i?.trim().toLowerCase()?.replace?.(" ", "_")}_${index}`}
        >
          <span>{i}</span>
          <br />
        </Fragment>
      ))}
    </>
  );
};

export const mapVehicleTimelineToCarHistoryEvents = (
  vehicleTimeline: VehicleTimeline,
  t?: TranslationFunction
): CarHistoryEvent[] => {
  return vehicleTimeline.entries
    .map((entry: VehicleTimelineEntry) => {
      const eventDate = new Date(entry.date);
      const formattedDate = eventDate.toLocaleDateString("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

      // Mapowanie typu wydarzenia do prawidłowych typów CarHistoryEventType
      let eventType: CarHistoryEvent["type"] = "other";
      let eventTitle =
        entry.name && entry.name.length > 0
          ? entry.name
          : t
            ? t("timeline.event_titles.other_event", "Inne zdarzenie")
            : "Inne zdarzenie";
      let eventDescriptionName = entry.name || "";
      let eventDescription;

      switch (entry.type) {
        case VehicleTimelineEventType.ACCIDENT:
        case VehicleTimelineEventType.DAMAGE:
          eventType = "accident";
          eventTitle = t
            ? t("timeline.event_titles.vehicle_damage", "Szkoda pojazdu")
            : "Szkoda pojazdu";
          // eventDescription = entry.damages?.value
          //   ? t
          //     ? t("timeline.damage_value_label", "Wartość szkody: {{value}}", {
          //         value: entry.damages.value.toString(),
          //       })
          //     : `Wartość szkody: ${entry.damages.value}`
          //   : t
          //   ? t("timeline.event_titles.vehicle_damage", "Szkoda pojazdu")
          //   : "Szkoda pojazdu";
          eventDescription = parseDescription(entry.description) || "";
          break;
        case VehicleTimelineEventType.INSPECTION:
        case VehicleTimelineEventType.PeriodicTechnicalInspection:
        case VehicleTimelineEventType.PeriodicTechnicalInspectionOdometerRollback:
          eventType = "technical_inspection";
          eventTitle = t
            ? t(
              "timeline.event_titles.technical_inspection",
              "Przegląd techniczny"
            )
            : "Przegląd techniczny";
          eventDescriptionName = entry.name || "";
          eventDescription =
            parseDescription(entry.description) ||
            (t
              ? t(
                "timeline.event_titles.technical_inspection_vehicle",
                "Przegląd techniczny pojazdu"
              )
              : "Przegląd techniczny pojazdu");
          break;
        case VehicleTimelineEventType.REGISTRATION:
        case VehicleTimelineEventType.OwnershipTransfer:
        case VehicleTimelineEventType.CoOwnerAdded:
        case VehicleTimelineEventType.OwnerChange:
          // Sprawdzamy czy to pierwsza rejestracja po dacie produkcji
          eventType = "owner_change";
          eventTitle = t
            ? t("timeline.event_titles.owner_change", "Zmiana właściciela")
            : "Zmiana właściciela";
          eventDescription = parseDescription(entry.description);
          break;
        case VehicleTimelineEventType.InsuranceExpiry:
          eventType = "other";
          eventTitle = t
            ? t(
              "timeline.event_titles.insurance_expiry",
              "Wygaśnięcie ubezpieczenia"
            )
            : "Wygaśnięcie ubezpieczenia";
          eventDescription = parseDescription(entry.description);
          break;
        case VehicleTimelineEventType.CoOwnerAdded:
          eventType = "other";
          eventTitle = t
            ? t(
              "timeline.event_titles.co_owner_added",
              "Dodanie współwłaściciela"
            )
            : "Dodanie współwłaściciela";
          eventDescription = parseDescription(entry.description);
          break;
        case VehicleTimelineEventType.OdometerReadingDuringInspection:
          eventType = "mileage_report";
          eventTitle = t
            ? t(
              "timeline.event_titles.odometer_reading_during_inspection",
              "Odczyt przebiegu podczas kontroli"
            )
            : "Odczyt przebiegu podczas kontroli";
          eventDescription =
            parseDescription(entry.description) ||
            (entry.mileage
              ? t
                ? t(
                  "timeline.event_titles.odometer_reading_during_inspection_with_mileage",
                  "Odczyt przebiegu podczas kontroli {{mileage}} km.",
                  { mileage: entry.mileage.toString() }
                )
                : `Odczyt przebiegu podczas kontroli ${entry.mileage} km.`
              : "");
          break;
        case VehicleTimelineEventType.FirstRegistrationInPoland:
          eventType = "first_registration";
          eventTitle = t
            ? t(
              "timeline.event_titles.first_registration_in_poland",
              "Pierwsza rejestracja w Polsce"
            )
            : "Pierwsza rejestracja w Polsce";
          eventDescription =
            parseDescription(entry.description) ||
            (t
              ? t(
                "timeline.event_titles.first_registration_in_poland",
                "Pierwsza rejestracja w Polsce"
              )
              : "Pierwsza rejestracja w Polsce");
          break;
        case VehicleTimelineEventType.FirstRegistration:
          eventType = "first_registration";
          eventTitle = t
            ? t(
              "timeline.event_titles.first_registration",
              "Pierwsza rejestracja pojazdu"
            )
            : "Pierwsza rejestracja pojazdu";
          eventDescription = parseDescription(entry.description) || "";
          break;
        case VehicleTimelineEventType.Sale:
          eventType = "owner_change";
          eventTitle = t
            ? t("timeline.event_titles.sale", "Sprzedaż pojazdu")
            : "Sprzedaż pojazdu";
          eventDescriptionName = entry.name || "";
          eventDescription = parseDescription(entry.description) || "";
          break;
        case VehicleTimelineEventType.Other:
          eventType = "other";
          eventTitle = eventTitle;
          eventDescriptionName = "";
          eventDescription = parseDescription(entry.description) || "";
          break;
        case VehicleTimelineEventType.FirstOwner:
          eventType = "owner_change";
          eventTitle = t
            ? t(
              "timeline.event_titles.first_owner_in_poland",
              "Pierwszy właściciel w Polsce"
            )
            : "Pierwszy właściciel w Polsce";
          eventDescription = parseDescription(entry.description) || "";
          break;
        default:
          eventType = "other";
          eventTitle = eventTitle;
          eventDescription = parseDescription(entry.description) || "";
      }

      return {
        id: entry.details?.claimId,
        date: formattedDate,
        type: eventType,
        title: eventTitle,
        descriptionName: eventDescriptionName,
        description: eventDescription,
        details: {
          claimId: entry.details?.claimId || entry.claimId,
          originalDate: entry.date,
          damageValue: entry.damages?.value,
          damageTypes: entry.damages?.types || [],
          mileage: entry.mileage,
          voivodeship: entry.location,
          inspectionResult: entry.details?.hasOwnProperty("inspectionPassed")
            ? entry.details?.inspectionPassed
              ? "positive"
              : "negative"
            : "positive",
          ...entry.details,
        },
      } as CarHistoryEvent;
    })
    .sort((a, b) => {
      const aDate = (a as any).details?.originalDate || a.date;
      const bDate = (b as any).details?.originalDate || b.date;
      return new Date(bDate).getTime() - new Date(aDate).getTime();
    });
};

export const createTimelineHistoryData = (
  vehicleTimeline?: VehicleTimeline,
  t?: TranslationFunction
): RaportHSPHistoryData => {
  if (!vehicleTimeline) {
    return {
      timeline: [],
      statistics: {
        totalOwners: 0,
        averageOwnershipTime: t
          ? t("timeline.statistics.no_data", "Brak danych")
          : "Brak danych",
        mileageProgression: t
          ? t("timeline.statistics.no_data", "Brak danych")
          : "Brak danych",
        registrationChanges: 0,
      },
    };
  }

  const timeline = mapVehicleTimelineToCarHistoryEvents(vehicleTimeline, t);
  // Obliczanie statystyk
  const damageEvents = vehicleTimeline.entries.filter(
    (entry) =>
      entry.type === VehicleTimelineEventType.DAMAGE ||
      entry.type === VehicleTimelineEventType.ACCIDENT
  );
  const registrationEvents = vehicleTimeline.entries.filter(
    (entry) => entry.type === VehicleTimelineEventType.REGISTRATION
  );
  const mileageEntries = vehicleTimeline.entries.filter(
    (entry) => entry.mileage && entry.mileage > 0
  );

  let mileageProgression = t
    ? t("timeline.statistics.no_data", "Brak danych")
    : "Brak danych";
  if (mileageEntries.length >= 2) {
    const sortedMileage = mileageEntries.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );
    const firstMileage = sortedMileage[0].mileage!;
    const lastMileage = sortedMileage[sortedMileage.length - 1].mileage!;
    const yearsDiff =
      (new Date(sortedMileage[sortedMileage.length - 1].date).getTime() -
        new Date(sortedMileage[0].date).getTime()) /
      (1000 * 60 * 60 * 24 * 365);
    const avgPerYear = Math.round((lastMileage - firstMileage) / yearsDiff);
    mileageProgression = t
      ? t("timeline.statistics.mileage_progression", "{{value}} km/rok", {
        value: avgPerYear.toString(),
      })
      : `${avgPerYear} km/rok`;
  }

  return {
    timeline,
    statistics: {
      totalOwners: Math.max(1, registrationEvents.length), // Przynajmniej 1 właściciel
      averageOwnershipTime: t
        ? t("timeline.statistics.no_data", "Brak danych")
        : "Brak danych", // Wymagałoby to dodatkowych danych o właścicielach
      mileageProgression,
      registrationChanges: registrationEvents.length,
    },
    registrationStatus: vehicleTimeline.registrationStatus,
    technicalInspectionCurrent: vehicleTimeline.technicalInspectionCurrent,
    insuranceExpiryDate: vehicleTimeline.insuranceExpiryDate,
    hasCurrentOCPolicy: vehicleTimeline.hasCurrentOCPolicy,
    document: vehicleTimeline.document,
  };
};
